(function(){
  'use strict';
  // UX membership verification only. This MUST NEVER issue a checkout reward:
  // game results are currently generated in localStorage and are untrusted.
  var KEY='sultaneaClubSignedCardV1';
  var ENDPOINT='https://sultanea-perfume.vercel.app/api/club-scan';
  var VALID=/^[A-Za-z0-9_-]{20,2500}\.[A-Za-z0-9_-]{20,250}$/;
  var running='',validated='',requestNumber=0;
  window.sultaneaJackpotClubVerified=false;
  function token(){try{var val=localStorage.getItem(KEY)||'';return VALID.test(val)?val:'';}catch(_){return '';}}
  function render(verified,memberCode){
    window.sultaneaJackpotClubVerified=!!verified;
    document.documentElement.classList.toggle('sj-club-is-verified',!!verified);
    var roots=document.querySelectorAll('[data-sj-root]');
    roots.forEach(function(root){
      root.querySelectorAll('[data-sj-club-warning]').forEach(function(el){el.hidden=!!verified;});
      var notice=root.querySelector('[data-sj-club-verified]');
      if(notice){
        notice.hidden=!verified;
        var code=notice.querySelector('[data-sj-club-code]');
        if(code)code.textContent=verified?'Número de socio: '+memberCode:'';
      }
    });
    document.querySelectorAll('.sj-mini-gift__member').forEach(function(el){el.hidden=!!verified;});
    try{document.dispatchEvent(new CustomEvent('sultanea-jackpot-club-status',{detail:{verified:!!verified,memberCode:verified?memberCode:''}}));}catch(_){}
  }
  function verify(){
    var key=token();
    if(!key){validated='';running='';requestNumber++;render(false,'');return;}
    if(validated===key)return;
    if(running===key)return;
    var current=++requestNumber;
    running=key;
    // No personal card token is added to a URL or stored in checkout properties.
    fetch(ENDPOINT,{
      method:'POST',mode:'cors',credentials:'omit',cache:'no-store',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'jackpot_verify',value:key})
    }).then(function(response){if(!response.ok)throw Error('Club no verificado');return response.json();})
      .then(function(data){
        if(current!==requestNumber||token()!==key)return;
        if(data&&data.ok===true&&data.verified===true&&/^SUL-\d{8}$/.test(data.memberCode||'')){
          validated=key;render(true,data.memberCode);
        }else{validated='';render(false,'');}
      }).catch(function(){
        if(current!==requestNumber||token()!==key)return;
        validated='';render(false,'');
      }).finally(function(){if(current===requestNumber)running='';});
  }
  document.addEventListener('DOMContentLoaded',verify);
  window.addEventListener('pageshow',verify);
  window.addEventListener('focus',verify);
  window.addEventListener('storage',function(e){if(e.key===KEY)verify();});
  window.addEventListener('sultanea-club-token-changed',verify);
  if(document.readyState!=='loading')verify();
})();
